import { createActions } from '@redux-async-module/actions-utils';

import { NAMESPACE, StartPayload, SuccessPayload } from './types';

export const createUpdateDraft = createActions<StartPayload, SuccessPayload>(
  NAMESPACE,
  'CREATE_UPDATE_DRAFT',
);
